(function(){

  $(document).ready(function(){
    var quantityCounter = 1;
    $(".quantity__button").on("click", function() {
      

      if($(this).hasClass("quantity__button-plus")) {

        var itemValue = $(this).parent().find(".quantity__input").val();
        var itemMax = parseInt($(this).parent().find(".quantity__input").attr("max"));


        if(quantityCounter === itemMax) {
          $(this).parents(".product-form__buttons").find(".limit-reach-message").show();
        }

        if(quantityCounter < itemMax) {
          quantityCounter  += 1;
        }

        
      } else if($(this).hasClass("quantity__button-minus")) {
        var itemMin = parseInt($(this).parent().find(".quantity__input").attr("min"));

        $(this).parents(".product-form__buttons").find(".limit-reach-message").hide();
        
        if(quantityCounter > itemMin) {
          quantityCounter -= 1;
        }
        
      }

    });

  })

  
})();